module.exports = __webpack_public_path__ + "static/media/logo-WCCE.c7961685.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/logo-WCCE.svg
// module id = 164
// module chunks = 0